export default {
  columnMoveMove: '<span class="icon icon-drag" />',
  sortAscending: '<div class="listIconContainer"><span class="listIcon icon icon-sort_up" /></div>',
  sortDescending: '<div class="listIconContainer"><span class="listIcon icon icon-sort_down" /></div>',
  filter: '<div></div>',
  menu: '<div class="listIconContainer"><span class="listIcon icon icon-filter" /></div>',
}
